import type { SVGProps } from 'react'

const QrCodePlaceholder = (props: SVGProps<SVGSVGElement>) => (
	<svg
		width={40}
		height={40}
		viewBox="0 0 40 40"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<g clipPath="url(#a)" fill="#0A0909">
			<path d="M12.59 8.912H8.821v3.766h3.77zm12.36 19.715h-3.766v3.769h3.766zm11.3-3.767h-3.767v3.767h3.767z" />
			<path d="M28.714 24.86H24.95v-3.764h-3.766v3.766h3.766v3.765h3.767v-3.765h3.765v-3.766h-3.768zm3.767 7.533h-3.767v3.767h3.767zM4.838 17.752h11.736c.6 0 1.087-.487 1.088-1.087V4.928c0-.602-.487-1.088-1.088-1.088H4.838c-.601 0-1.088.486-1.088 1.088v11.737c0 .6.487 1.087 1.088 1.087M5.925 6.015h9.561v9.562h-9.56zm23.952 2.897H26.11v3.766h3.767z" />
			<path d="M22.124 17.752h11.738c.601 0 1.088-.487 1.088-1.087V4.928c0-.602-.486-1.088-1.088-1.088H22.124c-.601 0-1.088.486-1.088 1.088v11.736c0 .601.487 1.088 1.088 1.088m1.087-11.737h9.564v9.562H23.21zM12.613 26.173H8.847v3.767h3.766z" />
			<path d="M16.6 21.1H4.86c-.6 0-1.088.486-1.088 1.087v11.738c0 .6.487 1.087 1.088 1.087H16.6c.6 0 1.087-.487 1.088-1.087V22.187c0-.6-.487-1.088-1.088-1.088m-1.088 11.737H5.949v-9.562h9.563z" />
		</g>
		<defs>
			<clipPath id="a">
				<path fill="#fff" d="M3.75 3.75h32.5v32.5H3.75z" />
			</clipPath>
		</defs>
	</svg>
)
export default QrCodePlaceholder
